import { upsertApiKeyRpc as anthropicApiKeyRpc } from '../../../../__generated__/chirp/com/hubspot/anthropic/integration/rpc/AppSettingsRpc';
import { upsertApiKeyRpc as cohereApiKeyRpc } from '../../../../__generated__/chirp/com/hubspot/cohere/integration/rpc/AppSettingsRpc';
import { upsertApiKeyRpc as geminiUpsertApiKeyRpc } from '../../../../__generated__/chirp/com/hubspot/gemini/integration/rpc/AppSettingsRpc';
import { upsertApiKeyRpc as openaiUpsertApiKeyRpc } from '../../../../__generated__/chirp/com/hubspot/openai/integration/rpc/AppSettingsRpc';
import { upsertApiKeyRpc as xaiUpsertApiKeyRpc } from '../../../../__generated__/chirp/com/hubspot/x/ai/integration/rpc/AppSettingsRpc';
import { chirpClient } from '../../../apiClients/chirpClient';
const createApiKeyUpdateRequest = upsertApiKeyRpc => {
  return request => chirpClient.call(upsertApiKeyRpc, {
    request
  }).then(data => {
    if ('rpcError' in data) {
      return {
        error: data.rpcError
      };
    }
    return data;
  }).catch(e => {
    return {
      error: e
    };
  });
};
export const updateAnthropicApiKey = createApiKeyUpdateRequest(anthropicApiKeyRpc);
export const updateCohereApiKey = createApiKeyUpdateRequest(cohereApiKeyRpc);
export const updateGeminiApiKey = createApiKeyUpdateRequest(geminiUpsertApiKeyRpc);
export const updateOpenaiApiKey = createApiKeyUpdateRequest(openaiUpsertApiKeyRpc);
export const updateXaiApiKey = createApiKeyUpdateRequest(xaiUpsertApiKeyRpc);